import { Component, OnInit, ViewEncapsulation} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { UserService } from "../../core/services/user.service";
import { WishListService } from "../../core/services/wish-list.service";

@Component({
    selector: 'app-user-profile',
    templateUrl: './user-profile.component.html',
    styleUrls: ['./user-profile.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class UserProfileComponent implements OnInit {
    boughtCourses: Array<any>;
    wishList: Array<any> = [];

    showSections = {
        'showProfile': true,
        'showFavorites': false,
        'showCourses': false
    };

    dataIsAvailable = false;

    constructor(private router: Router,
                private activatedRoute: ActivatedRoute,
                private userService: UserService,
                private wishListService: WishListService) {}

    ngOnInit() {
        this.getUserInfo();
        this.activatedRoute.fragment.subscribe(section => {
            if (section) {
                this.showSection(section);
            }
        })
    }

    getUserInfo() {
        this.boughtCourses = this.userService.getBoughtCourses();
        this.wishList = this.wishListService.getWishList();
        this.dataIsAvailable = true;
    }

    showSection(section) {
        for (let key in this.showSections) {
            this.showSections[key] = false;
        }
        this.showSections[section] = true;
    }

    outputFullName() {
        return this.userService.getUserFullName();
    }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/(IGH Projects)/jobs/EVFS PROD_FRONTEND granima.de/workspace/frontend/src/app/pages/user-profile/user-profile.component.ts